import videojs, { VideoJsPlayer } from 'video.js';

import CustomFullscreenToggle from '../CustomFullscreenToggle';

export const ErrorDisplay = videojs.getComponent('ErrorDisplay');

class CustomErrorDisplay extends ErrorDisplay {
  closeFullscreenToggle?: CustomFullscreenToggle;

  constructor(player: VideoJsPlayer, options?: videojs.ComponentOptions) {
    super(player, options);

    const iconEl = videojs.dom.createEl('div', {
      className: `vjs-modal-dialog-icon`,
    });

    this.el().appendChild(iconEl);

    // closeButton default is disabled, enable in beforeSetup.ts by setting uncloseable as false
    const closeButton = this.getChild('closeButton');

    closeButton?.on('close', () => {
      this.player_.error(null);
    });

    this.createCloseFullscreenToggle();
  }

  private createCloseFullscreenToggle() {
    const originalContentEl = this.contentEl();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.contentEl_ = this.el(); // temp mutate contentEl
    this.closeFullscreenToggle = this.addChild(
      'fullscreenToggle'
    ) as CustomFullscreenToggle;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.contentEl_ = originalContentEl; // undo mutate
  }

  content() {
    return super.content() || '影片播放發生錯誤'; // TODO confirm default error message
  }
}

// override video.js original ErrorDisplay
videojs.registerComponent('ErrorDisplay', CustomErrorDisplay);

export default CustomErrorDisplay;
